import { createStore } from 'vuex'

export default createStore({
  state: {
    imgPath: 'https://service.psa-ict.co.kr/files/homePage_files/service_file/image/',
    videoPath: 'https://service.psa-ict.co.kr/files/homePage_files/service_file/video/',
    filePath: 'https://service.psa-ict.co.kr/files/homePage_files/service_file/file/',
    boardFilePath: 'https://www.psa-ict.co.kr/board/data/'
  },
  getters: {
    getUrlPath (state) {
      return state.urlpath
    },
    getImgPath (state) {
      return state.urlpath + state.imgPath
    },
    getVideoPath (state) {
      return state.urlpath + state.videoPath
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
